import Lottie, { Options } from "react-lottie";

import { defaultOptions } from "../defaultProps";
import { LottieProps } from "../types";
import animation from "./json.json";

export function LSuccessIcon({ options = defaultOptions, ...props }: LottieProps) {
  const newOptions = {
    ...options,
    animationData: animation
  } as Options;

  return <Lottie {...props} options={newOptions} />;
}
